import type { CentrifugeMessage } from '../messageTypes';

export interface ServiceCastBlockMessage {
  data: {
    type: 'ServiceCastBlock';
    message: {
      site: string;
    };
    created_at?: number;
  };
  offset: number;
}

export const isServiceCastBlockMessage = (item: CentrifugeMessage): item is ServiceCastBlockMessage => {
  return item.data.type === 'ServiceCastBlock';
};
